module.exports = __webpack_public_path__ + "img/20@2x.cb179739.png";